export const onboardingProcessSteps = {
  WELCOME: 'onboarding.welcome',
  BRAND: 'onboarding.brand-definition',
  LOCATION: 'onboarding.location-definition',
};
